// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/services/web/auth.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "api.devplan.services.web.auth";

export interface VerifyRecaptchaRequest {
  token: string;
}

export interface VerifyRecaptchaResponse {
  verified: boolean;
}

export interface RecaptchaConfigResponse {
  siteKey: string;
  enterprise: boolean;
  emergencyBypass: boolean;
}

export interface MagicLinkRequest {
  email: string;
  redirectTo?: string | undefined;
  recaptchaToken: string;
}

export interface MagicLinkResponse {
  sent: boolean;
  callbackUrl?: string | undefined;
}

export interface EarlyAccessRequest {
  email: string;
  message?: string | undefined;
  recaptchaToken: string;
}

export interface EarlyAccessResponse {
  ok: boolean;
}

function createBaseVerifyRecaptchaRequest(): VerifyRecaptchaRequest {
  return { token: "" };
}

export const VerifyRecaptchaRequest: MessageFns<VerifyRecaptchaRequest> = {
  encode(message: VerifyRecaptchaRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyRecaptchaRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyRecaptchaRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.token = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyRecaptchaRequest {
    return { token: isSet(object.token) ? globalThis.String(object.token) : "" };
  },

  toJSON(message: VerifyRecaptchaRequest): unknown {
    const obj: any = {};
    if (message.token !== "") {
      obj.token = message.token;
    }
    return obj;
  },

  create(base?: DeepPartial<VerifyRecaptchaRequest>): VerifyRecaptchaRequest {
    return VerifyRecaptchaRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VerifyRecaptchaRequest>): VerifyRecaptchaRequest {
    const message = createBaseVerifyRecaptchaRequest();
    message.token = object.token ?? "";
    return message;
  },
};

function createBaseVerifyRecaptchaResponse(): VerifyRecaptchaResponse {
  return { verified: false };
}

export const VerifyRecaptchaResponse: MessageFns<VerifyRecaptchaResponse> = {
  encode(message: VerifyRecaptchaResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.verified !== false) {
      writer.uint32(8).bool(message.verified);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyRecaptchaResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyRecaptchaResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.verified = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyRecaptchaResponse {
    return { verified: isSet(object.verified) ? globalThis.Boolean(object.verified) : false };
  },

  toJSON(message: VerifyRecaptchaResponse): unknown {
    const obj: any = {};
    if (message.verified !== false) {
      obj.verified = message.verified;
    }
    return obj;
  },

  create(base?: DeepPartial<VerifyRecaptchaResponse>): VerifyRecaptchaResponse {
    return VerifyRecaptchaResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VerifyRecaptchaResponse>): VerifyRecaptchaResponse {
    const message = createBaseVerifyRecaptchaResponse();
    message.verified = object.verified ?? false;
    return message;
  },
};

function createBaseRecaptchaConfigResponse(): RecaptchaConfigResponse {
  return { siteKey: "", enterprise: false, emergencyBypass: false };
}

export const RecaptchaConfigResponse: MessageFns<RecaptchaConfigResponse> = {
  encode(message: RecaptchaConfigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteKey !== "") {
      writer.uint32(10).string(message.siteKey);
    }
    if (message.enterprise !== false) {
      writer.uint32(16).bool(message.enterprise);
    }
    if (message.emergencyBypass !== false) {
      writer.uint32(24).bool(message.emergencyBypass);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecaptchaConfigResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecaptchaConfigResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.siteKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enterprise = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.emergencyBypass = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RecaptchaConfigResponse {
    return {
      siteKey: isSet(object.siteKey)
        ? globalThis.String(object.siteKey)
        : isSet(object.site_key)
        ? globalThis.String(object.site_key)
        : "",
      enterprise: isSet(object.enterprise) ? globalThis.Boolean(object.enterprise) : false,
      emergencyBypass: isSet(object.emergencyBypass)
        ? globalThis.Boolean(object.emergencyBypass)
        : isSet(object.emergency_bypass)
        ? globalThis.Boolean(object.emergency_bypass)
        : false,
    };
  },

  toJSON(message: RecaptchaConfigResponse): unknown {
    const obj: any = {};
    if (message.siteKey !== "") {
      obj.siteKey = message.siteKey;
    }
    if (message.enterprise !== false) {
      obj.enterprise = message.enterprise;
    }
    if (message.emergencyBypass !== false) {
      obj.emergencyBypass = message.emergencyBypass;
    }
    return obj;
  },

  create(base?: DeepPartial<RecaptchaConfigResponse>): RecaptchaConfigResponse {
    return RecaptchaConfigResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RecaptchaConfigResponse>): RecaptchaConfigResponse {
    const message = createBaseRecaptchaConfigResponse();
    message.siteKey = object.siteKey ?? "";
    message.enterprise = object.enterprise ?? false;
    message.emergencyBypass = object.emergencyBypass ?? false;
    return message;
  },
};

function createBaseMagicLinkRequest(): MagicLinkRequest {
  return { email: "", redirectTo: undefined, recaptchaToken: "" };
}

export const MagicLinkRequest: MessageFns<MagicLinkRequest> = {
  encode(message: MagicLinkRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.redirectTo !== undefined) {
      writer.uint32(18).string(message.redirectTo);
    }
    if (message.recaptchaToken !== "") {
      writer.uint32(26).string(message.recaptchaToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MagicLinkRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMagicLinkRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.redirectTo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.recaptchaToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MagicLinkRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      redirectTo: isSet(object.redirectTo)
        ? globalThis.String(object.redirectTo)
        : isSet(object.redirect_to)
        ? globalThis.String(object.redirect_to)
        : undefined,
      recaptchaToken: isSet(object.recaptchaToken)
        ? globalThis.String(object.recaptchaToken)
        : isSet(object.recaptcha_token)
        ? globalThis.String(object.recaptcha_token)
        : "",
    };
  },

  toJSON(message: MagicLinkRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.redirectTo !== undefined) {
      obj.redirectTo = message.redirectTo;
    }
    if (message.recaptchaToken !== "") {
      obj.recaptchaToken = message.recaptchaToken;
    }
    return obj;
  },

  create(base?: DeepPartial<MagicLinkRequest>): MagicLinkRequest {
    return MagicLinkRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MagicLinkRequest>): MagicLinkRequest {
    const message = createBaseMagicLinkRequest();
    message.email = object.email ?? "";
    message.redirectTo = object.redirectTo ?? undefined;
    message.recaptchaToken = object.recaptchaToken ?? "";
    return message;
  },
};

function createBaseMagicLinkResponse(): MagicLinkResponse {
  return { sent: false, callbackUrl: undefined };
}

export const MagicLinkResponse: MessageFns<MagicLinkResponse> = {
  encode(message: MagicLinkResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sent !== false) {
      writer.uint32(8).bool(message.sent);
    }
    if (message.callbackUrl !== undefined) {
      writer.uint32(18).string(message.callbackUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MagicLinkResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMagicLinkResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sent = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.callbackUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MagicLinkResponse {
    return {
      sent: isSet(object.sent) ? globalThis.Boolean(object.sent) : false,
      callbackUrl: isSet(object.callbackUrl)
        ? globalThis.String(object.callbackUrl)
        : isSet(object.callback_url)
        ? globalThis.String(object.callback_url)
        : undefined,
    };
  },

  toJSON(message: MagicLinkResponse): unknown {
    const obj: any = {};
    if (message.sent !== false) {
      obj.sent = message.sent;
    }
    if (message.callbackUrl !== undefined) {
      obj.callbackUrl = message.callbackUrl;
    }
    return obj;
  },

  create(base?: DeepPartial<MagicLinkResponse>): MagicLinkResponse {
    return MagicLinkResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MagicLinkResponse>): MagicLinkResponse {
    const message = createBaseMagicLinkResponse();
    message.sent = object.sent ?? false;
    message.callbackUrl = object.callbackUrl ?? undefined;
    return message;
  },
};

function createBaseEarlyAccessRequest(): EarlyAccessRequest {
  return { email: "", message: undefined, recaptchaToken: "" };
}

export const EarlyAccessRequest: MessageFns<EarlyAccessRequest> = {
  encode(message: EarlyAccessRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.message !== undefined) {
      writer.uint32(18).string(message.message);
    }
    if (message.recaptchaToken !== "") {
      writer.uint32(26).string(message.recaptchaToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EarlyAccessRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEarlyAccessRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.recaptchaToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EarlyAccessRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
      recaptchaToken: isSet(object.recaptchaToken)
        ? globalThis.String(object.recaptchaToken)
        : isSet(object.recaptcha_token)
        ? globalThis.String(object.recaptcha_token)
        : "",
    };
  },

  toJSON(message: EarlyAccessRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    if (message.recaptchaToken !== "") {
      obj.recaptchaToken = message.recaptchaToken;
    }
    return obj;
  },

  create(base?: DeepPartial<EarlyAccessRequest>): EarlyAccessRequest {
    return EarlyAccessRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EarlyAccessRequest>): EarlyAccessRequest {
    const message = createBaseEarlyAccessRequest();
    message.email = object.email ?? "";
    message.message = object.message ?? undefined;
    message.recaptchaToken = object.recaptchaToken ?? "";
    return message;
  },
};

function createBaseEarlyAccessResponse(): EarlyAccessResponse {
  return { ok: false };
}

export const EarlyAccessResponse: MessageFns<EarlyAccessResponse> = {
  encode(message: EarlyAccessResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ok !== false) {
      writer.uint32(8).bool(message.ok);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EarlyAccessResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEarlyAccessResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.ok = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EarlyAccessResponse {
    return { ok: isSet(object.ok) ? globalThis.Boolean(object.ok) : false };
  },

  toJSON(message: EarlyAccessResponse): unknown {
    const obj: any = {};
    if (message.ok !== false) {
      obj.ok = message.ok;
    }
    return obj;
  },

  create(base?: DeepPartial<EarlyAccessResponse>): EarlyAccessResponse {
    return EarlyAccessResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EarlyAccessResponse>): EarlyAccessResponse {
    const message = createBaseEarlyAccessResponse();
    message.ok = object.ok ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
